import NotQualifiedScreenIconSrc from '@ui/assets/images/booking/not-qualified-screen-icon.svg'
import NoDiagnosisScreenIconSrc from '@ui/assets/images/booking/no-diagnosis-screen-icon.svg'
import DocumentIcon from '@ui/assets/images/booking/document-icon.svg'
import CallNowConfirmationScreenIconSrc from '@ui/assets/images/booking/call-now-confirmation-screen-icon.png'

export const screensData = {
  serviceSeletion: {
    title: 'Service Selection | Elemy',
    heading: 'How can we help you today?'
  },

  bookingPage: {
    title: 'Booking | Elemy',
    description: 'Skip the waitlist! Book an appointment with us today.'
  },

  zipCode: {
    heading: 'Welcome to Elemy',
    description: 'Enter your zip code so we can match you with a local therapist.',

    test1: {
      heading: 'Help your child thrive with personalized ABA therapy',
      description: 'To get matched with the right care near you, enter your zip code.'
    }
  },

  age: {
    heading: 'How Old Is Your Child?',
    description: 'We select therapists with the most experience working with your child’s age group.',

    test1: {
      heading: 'First, how old is your child?',
      description: 'To match you with experts in your child’s age group, share your child’s age.'
    }
  },

  ageInYears: {
    heading: 'Great, we are in your area! How old is your child?',
    description: 'To match you with experts in your child’s age group, let us know your child’s age.',

    test1: {
      heading: 'First, how old is your child?',
      description: 'To match you with experts in your child’s age group, share your child’s age.'
    }
  },

  isParent: {
    heading: "Are you the child's parent?",
    description: 'We just need to double check that we can work directly with you.'
  },

  legalGuardian: {
    heading: "Are you the child's legal guardian?",
    description: 'We just need to double check that we can work directly with you.'
  },

  diagnosis: {
    heading: 'Has Your Child Been Diagnosed With Autism Spectrum Disorder?',
    description:
      'This is a formal diagnosis typically given by a child psychologist, pediatric neurologist, or developmental pediatrician.',

    test1: {
      heading: 'Has your child been diagnosed with autism?',
      description: 'Whether you have a diagnosis or not, we’ll guide you toward the right care.'
    }
  },

  insurance: {
    heading: 'Do You Have Insurance?',
    description: 'Most insurance companies cover autism therapy. We’ll help you understand your coverage.',

    test1: {
      heading: 'Do you plan to use insurance?',
      description:
        'We’ll build a plan to cover costs unique to your family. If you have insurance, most providers cover autism therapy.'
    }
  },

  provider: {
    heading: 'What’s Your Insurance Provider?',
    description: 'We’ll check if your insurance is in-network.',

    test1: {
      heading: 'Which insurance provider will you use?',
      description:
        'A member of the Elemy team will work with your insurance provider to set up the most cost-efficient care.'
    }
  },

  parentInfo: {
    heading: "Let's Get Started",
    description:
      'Provide your information below, and we’ll reach out shortly with next steps. We keep all your data private.',

    test1: {
      heading: 'Care is one step closer',
      description:
        'To connect you with your Elemy Concierge, tell us a bit about yourself. They’ll answer any questions and share what’s next. '
    }
  },

  createAccount: {
    heading: 'Great news — your child is likely eligible for our care!',
    description: 'Create an account to start the Pre-Approval process and get matched with a care provider',

    test1: {
      heading: 'Care is one step closer',
      description:
        'To connect you with your Elemy Concierge, tell us a bit about yourself. They’ll answer any questions and share what’s next. '
    }
  },

  diagnosisOfframp: {
    heading: 'Elemy is now offering diagnostic evaluation in your area',
    description: '',
    imageSrc: DocumentIcon,
    imageAlt: ''
  },

  noDiagnosisOfframp: {
    heading: 'We can help your child in receiving a diagnosis',
    description: '',
    imageSrc: DocumentIcon,
    imageAlt: ''
  },

  notQualified: {
    heading: "We're unable to provide service right now.",
    imageSrc: NotQualifiedScreenIconSrc,
    imageAlt: 'We’re unable to provide service right now',

    noDiagnosis: {
      heading: 'No worries, we can help you start that process',
      description: 'Elemy offers services to assist you in getting a diagnostic evaluation for your child.',
      imageSrc: NoDiagnosisScreenIconSrc,
      imageAlt: ''
    },

    location: {
      heading: 'We aren’t near you — yet',
      description:
        'We’re working hard to make autism care accessible to everyone. If you share your contact info, we can pick up right where we left off when we expand to your area.',
      imageSrc: NotQualifiedScreenIconSrc,
      imageAlt: ''
    },

    age: {
      heading: 'We can’t support children over 10 — yet',
      description:
        'We’re working hard to make autism care accessible to everyone. If you share your contact info, we can pick up right where we left off when we expand our services.',
      imageSrc: NotQualifiedScreenIconSrc,
      imageAlt: ''
    }
  },

  timeSlots: {
    heading: "Your Child Is Likely Eligible for Our Care. What's Next?",
    description: {
      workingHours:
        'Have a 40 min call with a member of the Elemy team to learn how we can best support you and your child.',
      nonWorkingHours: 'Schedule a quick call to learn more and begin your child’s care.'
    },

    test1: {
      heading: {
        workingHours: 'Would you like to speak now or later?',
        nonWorkingHours: 'Your child is likely eligible for our care. What’s next?'
      },
      description: {
        workingHours: 'We’re here to answer all of your questions whenever works best for you.',
        nonWorkingHours: 'Schedule a quick call to learn more and begin your child’s care.'
      }
    }
  },

  schedulingConfirmation: {
    heading: 'Confirm The Date And Time For The Call',
    description: {
      desktop:
        'Have a 40 min call with a member of the Elemy team to learn how we can best support you and your child.',
      mobile: 'Schedule a quick call to learn more and begin your child’s care.'
    },

    test1: {
      heading: 'Almost done — just confirm the date and time',
      description: {
        desktop:
          'During your call, a member of the Elemy team will answer all of your questions and evaluate if your child is a good fit for Elemy. ',
        mobile:
          'During your call, a member of the Elemy team will answer all of your questions and evaluate if your child is a good fit for Elemy. '
      }
    }
  },

  callConfirmation: {
    callNow: {
      heading: 'Our Team Will Call You in 5 Minutes',
      description: 'If applicable, please make sure to have all the documents listed below ready for your call.',
      imageSrc: CallNowConfirmationScreenIconSrc,
      imageAlt: 'Concierge team member avatar'
    },

    callLater: {
      heading: 'Initial Call Is Confirmed!',
      description:
        'We sent you an email with your appointment details. If applicable, please have the documents below ready for your call.',

      test1: {
        heading: 'You’re on the calendar',
        description:
          'Try to get these documents handy before your call. If you can’t, no worries — we’ll work through the right next steps together.'
      }
    }
  },

  // A/B testing
  email: {
    heading: {
      supportedLocation: "Great news — we're in your area",
      notSupportedLocation: 'Match with the right care'
    },
    description: {
      supportedLocation:
        "Let's match you with the right care. Get the ball rolling by entering your email and answering a few questions.",
      notSupportedLocation: 'Get the ball rolling by entering your email and answering a few questions.'
    }
  },

  interstitials: {
    ageToDiagnosis: {
      screenDescription: `
      Our personalized, evidence-based ABA therapy improves behaviors <b>up to 85%</b> within the <b>first 6 months of care</b>.  
    `
    },

    diagnosisToInsurance: {
      screenDescription: `
      Our autism care is led by board-certified behavioral analysts with <b>9+ years of experience on average</b>. 
      <br />
      <br />
      We'll match your child with the right care team and develop a plan specific to your child's needs.
    `
    },

    insuranceToParentInfo: {
      screenDescription: `
      Early intervention is proven to produce better outcomes. That’s why we start autism care <b>4x faster</b> on average than other providers.
    `
    }
  }
}
